import { jsx as _jsx } from "react/jsx-runtime";
import ConfettiAnimation from 'components/AnimationEffects/ConfettiAnimation';
// https://lottiefiles.com/search?q=confetti&category=animations
// можно попробовать эти
var TestAnimationsDialog = function () {
    return (_jsx("div", { children: _jsx(ConfettiAnimation, {}, void 0) }, void 0));
};
export default TestAnimationsDialog;
